export const OTHER = "Other";

export const baseTruckFormState = {
  name: '',
  serial_number: '',
  license_plate: '',
  status: 'Active',
  row_color: '',
  category: '',
  make: '',
  model: '',
  year: new Date().getFullYear(),
  odometer: '',
  estimated_value: '',
  front_axle: '',
  rear_door_type: '',
  taillightDesign: '',
  taillightType: '',
  boxlightDesign: '',
  boxlightType: '',
  transmission: '',
  box: '',
  headlight_type: '',
  seats: '',
  tires: '',
  // conditions
  frame_condition: '',
  cab_condition: '',
  rear_door_condition: '',
  hood_condition: '',
  headlight_condition: '',
  taillight_condition: '',
  clutch: '',
  boxlight_condition: '',
  // equipment
  liftgate: '',
  liftgate_status: '',
  box_length: '',
  fuel_tank_number: '',
  fuel_tank_type: '',
  // electrical
  tricklecharger: '',
  battery: '',
  isolatorSwitch: '',
  // lights
  headlights_design_year: '',
  lightbar: '',
  interior_light_control_location: '',
  // invoice
  invoice_url: '',
  // photo
  photo_url: '',
  // notes
  important_notes: '',
  idiosyncrasies: '',
  // "Other" free-text fields (shown when select === OTHER)
  headlight_type_other: '',
  headlights_design_year_other: '',
  interior_light_control_location_other: '',
  taillightDesign_other: '',
  taillightType_other: '',
  boxlightDesign_other: '',
};

export const statusOptions = ['Active', 'Maintenance', 'Inactive', 'Out of Service'];
export const transmissionOptions = ['Automatic transmission', 'Manual transmission', 'Semi-automatic'];
export const rearDoorTypeOptions = [
  'Roll-Up Door',
  'Swing Doors (Barn Doors)',
  'Liftgate',
  'Tailgate',
  'Curtain Side',
  'Flatbed (No Rear Door)',
  'Refrigerated Door',
  'Dump Body Gate',
  'Hydraulic Rear Compactor Door',
  'Split Rear Compactor Door',
  'Rear Hopper Door',
  'Rear Loading Door',
  'Other',
];
export const lightingOptions = ['LED headlights', 'Halogen lights', 'HID (Xenon) lights', 'LED Projector', 'Halogen Projector', 'Standard', 'Other'];
export const seatOptions = ['Standard seats (spring)', 'Premium air-ride seats', 'Air-ride (aftermarket)', 'Air stock seats', 'Heated seats', 'Custom', 'Bench seat'];
export const conditionOptions = ['Excellent condition', 'Good condition', 'Fair condition', 'Poor condition', 'Needs repair'];
export const liftgateOptions = ['Yes', 'No'];
export const lightbarOptions = ['Yes', 'No'];
export const isolatorSwitchOption = ['Yes', 'No'];
export const trickleChargerOptions = ['Yes', 'No'];
export const batterySystemOptions = ['Single Battery System', 'Dual Battery System', 'Triple Battery System', 'Quad Battery System'];
export const liftgateStatusOptions = ['Operational', 'Non Operational'];
export const fuelTankTypeOptions = ['Aluminum', 'Steel'];
export const lightYearOptions = ['2005', '2006', 'Other'];
export const interiorLightControlOptions = ['Steering Column', 'Dashboard / Console', 'Inside Cargo Box', 'Rear Cargo Door', 'Other'];
export const taillightDesignOptions = ['Round', 'Oval', 'Rectangular', 'Vertical Stack', 'Integrated Assembly', 'Other'];
export const taillightTypeOptions = ['LED', 'Halogen', 'Incandescent', 'LED Combination', 'Mixed', 'Other'];
export const boxlightDesignOptions = ['Dome Light', 'LED Strip Light', 'Rectangular Utility Light', 'Round Utility Light', 'Surface Mount', 'Other'];
export const boxlightTypeOptions = ['LED', 'Halogen', 'Incandescent', 'Fluorescent'];

export const otherFieldMap = {
  headlight_type: "headlight_type_other",
  headlights_design_year: "headlights_design_year_other",
  interior_light_control_location: "interior_light_control_location_other",
  taillightDesign: "taillightDesign_other",
  taillightType: "taillightType_other",
  boxlightDesign: "boxlightDesign_other",
};

export function checkIsPdf(url) {
  if (!url) return false;
  try {
    return new URL(url, window.location.origin).pathname.toLowerCase().endsWith('.pdf');
  } catch {
    return url.toLowerCase().split('?')[0].endsWith('.pdf');
  }
}

export function parseInvoiceUrls(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {
      // Existing records stored one invoice URL as plain text.
    }
    return [trimmed];
  }
  return [];
}

export function serializeInvoiceUrls(urls) {
  const cleanUrls = (Array.isArray(urls) ? urls : []).filter(Boolean);
  if (cleanUrls.length === 0) return null;
  if (cleanUrls.length === 1) return cleanUrls[0];
  return JSON.stringify(cleanUrls);
}

export function invoiceDisplayName(url, fallback = 'Invoice') {
  if (!url) return fallback;
  try {
    const parsed = new URL(url, window.location.origin);
    const originalName = parsed.searchParams.get('filename');
    if (originalName) return originalName;
  } catch {
    // Fall back to the path for legacy invoice records.
  }
  const filename = extractInvoiceFilename(url);
  if (!filename) return fallback;
  try {
    return decodeURIComponent(filename);
  } catch {
    return filename;
  }
}

export function parseFuelTankCapacities(raw) {
  if (raw == null || raw === '') return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function extractInvoiceFilename(url) {
  if (!url) return null;
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    return pathname.split('/').pop() || null;
  } catch {
    const clean = url.split('?')[0];
    return clean.split('/').pop() || null;
  }
}
